import { AdminProfiles } from "src/types";

export const ProfileToLabel: { [key in AdminProfiles["name"]]: string } = {
  consulting: "Pessoa consultora",
  manager: "Gestor(a) de Carteira",
  admin: "Administrador",
};
